import * as React from "react";
import { SVGProps } from "react";
const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 13 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.28192 7.15981L7.0819 2.35983L10.588 2.56607L10.7942 6.07214L5.99423 10.8721L2.28192 7.15981ZM7.00187 0.85253C6.68109 0.83366 6.36754 0.95287 6.14032 1.18009L0.956092 6.36432C0.516752 6.80366 0.516752 7.51597 0.956092 7.95531L5.19873 12.1979C5.63807 12.6373 6.35038 12.6373 6.78972 12.1979L11.9739 7.01372C12.2012 6.7865 12.3204 6.47295 12.3015 6.15217L12.0658 2.14523C12.0323 1.57591 11.5781 1.12172 11.0088 1.08823L7.00187 0.85253ZM8.39638 4.74407C8.3932 4.7411 8.39006 4.73806 8.38696 4.73497C8.24052 4.58852 8.24052 4.35108 8.38696 4.20464C8.53021 4.06138 8.76053 4.05826 8.90759 4.19526C8.91076 4.19823 8.9139 4.20126 8.917 4.20436C9.06345 4.35081 9.06345 4.58825 8.917 4.73469C8.77375 4.87795 8.54343 4.88107 8.39638 4.74407ZM7.88386 5.29164C7.87457 5.28295 7.8654 5.27408 7.85634 5.26502C7.417 4.82568 7.417 4.11337 7.85634 3.67403C8.28672 3.24366 8.97904 3.23488 9.42011 3.64769C9.42939 3.65638 9.43857 3.66525 9.44762 3.67431C9.88697 4.11365 9.88696 4.82596 9.44762 5.2653C9.01725 5.69567 8.32492 5.70445 7.88386 5.29164ZM11.5628 9.01586L6.2595 14.3192L1.75169 9.81136L0.691031 10.872L5.464 15.645C5.90334 16.0843 6.61565 16.0843 7.05499 15.645L12.6235 10.0765L11.5628 9.01586Z"
      fill="white"
      fillOpacity={0.85}
    />
  </svg>
);
export default SVGComponent;
